export enum ExceptionMessage {
  LockedDpr = 'Locked Dpr',
  UnlockedOrNotLatestDpr = 'Dpr Not Locked or Not Latest Revision',
  AdminNotificationSyncError = 'Admin Notification Sync Error',
}
